// extracted by mini-css-extract-plugin
module.exports = {"dropdownToggle":"DropdownToggle_dropdownToggle__3H4B4","text":"DropdownToggle_text__1Q0HY","icon":"DropdownToggle_icon__3iEGR"};